import clsx from 'clsx';
import React from 'react';
import { factory } from '../../../../factory/factory.utils.mjs';
import { Box } from '../../../../Other/Box/Box.mjs';
import { RadioGroup } from '../../../RadioButton/RadioGroup/RadioGroup.mjs';
import { ColorSwatchRadioButton } from './ColorSwatchRadioButton/ColorSwatchRadioButton.mjs';
import classes from './ColorSwatchRadioGroup.module.css.mjs';

const ColorSwatchRadioGroup = factory((props, ref) => {
  const {
    defaultValue,
    onChange,
    value,
    colors,
    label,
    id,
    name,
    direction = "column",
    radioGroupClassname,
    ["aria-label"]: ariaLabel,
    ...rest
  } = props;
  return /* @__PURE__ */ React.createElement(Box, { component: "div", ref, ...rest }, /* @__PURE__ */ React.createElement(
    RadioGroup,
    {
      label,
      value,
      defaultValue,
      onChange,
      id,
      "aria-label": ariaLabel,
      name,
      radioGroupClassname: clsx(
        classes.colorSwatchRadioGroupInputs,
        radioGroupClassname,
        direction === "row" && classes.colorSwatchRadioGroupInputsRow
      )
    },
    colors.map((color) => /* @__PURE__ */ React.createElement(ColorSwatchRadioButton, { key: color.value, shape: color.shape || "square", size: "small", ...color }))
  ));
});

export { ColorSwatchRadioGroup };
